module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/vi-card-drag.8c27bf4c1414f3fb33df.gif";